var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1121_5270)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M130.662 40H5.6659C2.90918 40 0.664062 37.7456 0.664062 35V5C0.664062 2.24439 2.90918 0 5.6659 0H130.662C133.416 0 135.664 2.24439 135.664 5V35C135.664 37.7456 133.416 40 130.662 40Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M130.662 0.800499C132.974 0.800499 134.867 2.68828 134.867 5V35C134.867 37.3117 132.987 39.1995 130.662 39.1995H5.6659C3.35373 39.1995 1.46128 37.3117 1.46128 35V5C1.46128 2.68828 3.34131 0.800499 5.6659 0.800499C5.6659 0.800499 130.662 0.800499 130.662 0.800499ZM130.662 0H5.6659C2.90918 0 0.664062 2.25436 0.664062 5V35C0.664062 37.7556 2.90918 40 5.6659 40H130.662C133.416 40 135.664 37.7556 135.664 35V5C135.664 2.25436 133.416 0 130.662 0Z",
  fill: "#A6A6A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.7822 13.232C70.8807 13.232 70.1208 12.9153 69.5197 12.2918C68.9237 11.6858 68.5909 10.8504 68.6058 9.99755C68.6058 9.08732 68.9138 8.31675 69.5197 7.70577C70.1183 7.08233 70.8782 6.76562 71.7797 6.76562C72.6713 6.76562 73.4313 7.08233 74.0422 7.70577C74.6482 8.3367 74.9562 9.10727 74.9562 9.99755C74.9462 10.9103 74.6383 11.6808 74.0422 12.2893C73.4437 12.9177 72.6837 13.232 71.7822 13.232ZM44.9577 13.232C44.0761 13.232 43.3112 12.9202 42.6853 12.3043C42.0644 11.6908 41.749 10.9153 41.749 10C41.749 9.08483 42.0644 8.30927 42.6853 7.6958C43.2987 7.07984 44.0637 6.76812 44.9577 6.76812C45.3948 6.76812 45.8195 6.8554 46.2268 7.03246C46.6267 7.20453 46.952 7.43894 47.1929 7.72572L47.2525 7.79804L46.5795 8.46139L46.5099 8.37909C46.13 7.92523 45.6208 7.70328 44.9478 7.70328C44.3468 7.70328 43.8228 7.91775 43.3906 8.34169C42.956 8.76812 42.735 9.32672 42.735 10.0025C42.735 10.6783 42.956 11.2369 43.3906 11.6634C43.8228 12.0873 44.3468 12.3018 44.9478 12.3018C45.5885 12.3018 46.1275 12.0873 46.5472 11.6634C46.7955 11.414 46.9495 11.0649 47.0042 10.6235H44.846V9.69081H47.9305L47.9429 9.7756C47.9653 9.93271 47.9876 10.0948 47.9876 10.2444C47.9876 11.1048 47.7293 11.8005 47.2177 12.3143C46.6366 12.9227 45.8766 13.232 44.9577 13.232ZM80.6236 13.0998H79.6724L76.7592 8.41899L76.784 9.26188V13.0973H75.8328V6.90029H76.9181L76.948 6.94767L79.6873 11.3566L79.6624 10.5162V6.90029H80.6236V13.0998V13.0998ZM64.6347 13.0998H63.6711V7.83296H61.9996V6.90029H66.3036V7.83296H64.6322V13.0998H64.6347ZM61.2149 13.0998H60.2537V6.90029H61.2149V13.0998ZM55.8132 13.0998H54.8521V7.83296H53.1807V6.90029H57.4846V7.83296H55.8132V13.0998ZM52.5722 13.0898H48.8867V6.90029H52.5722V7.83296H49.8503V9.5337H52.3065V10.4564H49.8503V12.1571H52.5722V13.0898ZM70.2251 11.6509C70.6547 12.0823 71.1763 12.2993 71.7822 12.2993C72.4056 12.2993 72.9147 12.0873 73.3394 11.6509C73.7616 11.227 73.9752 10.6709 73.9752 10C73.9752 9.32922 73.7616 8.77061 73.3419 8.34917C72.9122 7.91774 72.3882 7.70079 71.7847 7.70079C71.1613 7.70079 70.6522 7.91276 70.23 8.34917C69.8078 8.77311 69.5942 9.32922 69.5942 10C69.5942 10.6709 69.8053 11.2295 70.2251 11.6509Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.5169 21.7557C66.1699 21.7557 64.2675 23.5437 64.2675 26.01C64.2675 28.4539 66.1823 30.2644 68.5169 30.2644C70.8638 30.2644 72.7662 28.4639 72.7662 26.01C72.7662 23.5437 70.8638 21.7557 68.5169 21.7557ZM68.5169 28.5786C67.2329 28.5786 66.1277 27.5113 66.1277 26.0001C66.1277 24.4664 67.2354 23.4215 68.5169 23.4215C69.8009 23.4215 70.906 24.4664 70.906 26.0001C70.9085 27.5212 69.8009 28.5786 68.5169 28.5786ZM59.2458 21.7557C56.8989 21.7557 54.9965 23.5437 54.9965 26.01C54.9965 28.4539 56.9113 30.2644 59.2458 30.2644C61.5928 30.2644 63.4952 28.4639 63.4952 26.01C63.4952 23.5437 61.5903 21.7557 59.2458 21.7557ZM59.2458 28.5786C57.9618 28.5786 56.8567 27.5113 56.8567 26.0001C56.8567 24.4664 57.9643 23.4215 59.2458 23.4215C60.5298 23.4215 61.635 24.4664 61.635 26.0001C61.635 27.5212 60.5298 28.5786 59.2458 28.5786ZM48.2139 23.0549V24.8554H52.5179C52.3863 25.8654 52.0535 26.611 51.5444 27.1222C50.9136 27.7557 49.94 28.4439 48.2239 28.4439C45.5789 28.4439 43.5101 26.2993 43.5101 23.6434C43.5101 20.9876 45.5789 18.8429 48.2239 18.8429C49.6519 18.8429 50.6925 19.409 51.4649 20.1322L52.7365 18.8554C51.6636 17.823 50.2355 17.0325 48.2338 17.0325C44.6054 17.0325 41.5605 20.0001 41.5605 23.6335C41.5605 27.2769 44.6029 30.2345 48.2338 30.2345C50.1933 30.2345 51.6636 29.5911 52.8259 28.3791C54.0105 27.1896 54.3855 25.5113 54.3855 24.1572C54.3855 23.7357 54.3533 23.3567 54.2862 23.035H48.2115C48.2139 23.0325 48.2139 23.0549 48.2139 23.0549ZM93.3374 24.4564C92.9822 23.5013 91.9093 21.7457 89.7089 21.7457C87.5284 21.7457 85.7154 23.4689 85.7154 26.0001C85.7154 28.3891 87.5085 30.2544 89.92 30.2544C91.8572 30.2544 92.9847 29.0649 93.4491 28.3666L92.0111 27.3991C91.5343 28.1098 90.8712 28.5761 89.9299 28.5761C88.9787 28.5761 88.3132 28.1422 87.8711 27.2868L93.536 24.9302C93.536 24.9327 93.3374 24.4564 93.3374 24.4564ZM87.5606 25.8779C87.5159 24.2345 88.8322 23.3991 89.7735 23.3991C90.5161 23.3991 91.1345 23.7656 91.3456 24.2993L87.5606 25.8779ZM82.9587 30.0001H84.8188V17.5013H82.9587V30.0001ZM79.9039 22.7008H79.8368C79.4171 22.1996 78.6199 21.7457 77.6017 21.7457C75.4882 21.7457 73.5411 23.6135 73.5411 26.0125C73.5411 28.4015 75.4782 30.2469 77.6017 30.2469C78.6075 30.2469 79.4171 29.7906 79.8368 29.2794H79.9039V29.8903C79.9039 31.5138 79.0396 32.3891 77.6464 32.3891C76.5064 32.3891 75.7986 31.5661 75.5105 30.8779L73.8937 31.5562C74.3582 32.6784 75.5974 34.0674 77.6439 34.0674C79.8244 34.0674 81.6722 32.7781 81.6722 29.6335V22.0001H79.9138V22.7008C79.9163 22.7008 79.9039 22.7008 79.9039 22.7008ZM77.7681 28.5786C76.4841 28.5786 75.4112 27.5013 75.4112 26.0125C75.4112 24.5113 76.4841 23.424 77.7681 23.424C79.0396 23.424 80.0256 24.5237 80.0256 26.0125C80.038 27.5013 79.0421 28.5786 77.7681 28.5786ZM102.047 17.5013H97.5991V30.0001H99.4593V25.2669H102.05C104.108 25.2669 106.133 23.7681 106.133 21.3891C106.133 19.01 104.116 17.5013 102.047 17.5013ZM102.102 23.5212H99.4568V19.232H102.102C103.495 19.232 104.282 20.3866 104.282 21.3766C104.282 22.3567 103.485 23.5212 102.102 23.5212ZM113.588 21.7332C112.237 21.7332 110.844 22.3342 110.268 23.6434L111.917 24.3317C112.272 23.6434 112.923 23.409 113.61 23.409C114.574 23.409 115.548 23.9876 115.57 25.02V25.1522C115.237 24.9626 114.507 24.6734 113.633 24.6734C111.852 24.6734 110.047 25.6509 110.047 27.4838C110.047 29.1621 111.507 30.2395 113.134 30.2395C114.383 30.2395 115.071 29.6734 115.5 29.0175H115.568V29.9851H117.361V25.1971C117.361 22.9676 115.712 21.7332 113.588 21.7332ZM113.355 28.5786C112.746 28.5786 111.894 28.2794 111.894 27.5113C111.894 26.5437 112.957 26.1771 113.864 26.1771C114.683 26.1771 115.071 26.3542 115.558 26.5986C115.423 27.7207 114.48 28.5686 113.355 28.5786ZM123.902 22.0001L121.766 27.4215H121.699L119.487 22.0001H117.485L120.805 29.5786L118.913 33.7906H120.85L125.959 22.0001H123.902ZM107.158 30.0001H109.018V17.5013H107.158V30.0001Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0551 7.53364C10.767 7.84536 10.6006 8.32167 10.6006 8.94511V31.0573C10.6006 31.6808 10.767 32.1571 11.065 32.4563L11.142 32.5237L23.4802 20.1346V19.8578L11.1321 7.46631L11.0551 7.53364Z",
  fill: "url(#paint0_linear_1121_5270)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.5859 24.2768L23.4707 20.1446V19.8553L27.5859 15.7231L27.6754 15.778L32.5431 18.5561C33.9364 19.3441 33.9364 20.6458 32.5431 21.4438L27.6754 24.2219L27.5859 24.2768Z",
  fill: "url(#paint1_linear_1121_5270)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.6745 24.2219L23.4699 20L11.0547 32.4663C11.5092 32.9551 12.2716 33.01 13.1235 32.5337L27.6745 24.2219Z",
  fill: "url(#paint2_linear_1121_5270)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.6745 15.7779L13.1235 7.47869C12.2716 6.98992 11.5067 7.05725 11.0547 7.54603L23.4699 19.9999L27.6745 15.7779Z",
  fill: "url(#paint3_linear_1121_5270)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.586 24.1323L13.1342 32.3767C12.3271 32.843 11.6068 32.8106 11.1424 32.3867L11.0654 32.464L11.1424 32.5313C11.6068 32.9527 12.3271 32.9877 13.1342 32.5213L27.6853 24.2221L27.586 24.1323Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.12,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.5428 21.2993L27.5732 24.1322L27.6626 24.2219L32.5304 21.4439C33.2282 21.0449 33.571 20.5212 33.571 20C33.5288 20.4788 33.1736 20.9327 32.5428 21.2993Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.1239 7.62354L32.5426 18.7008C33.1734 19.0575 33.5286 19.5238 33.5832 20.0001C33.5832 19.4789 33.2405 18.9552 32.5426 18.5562L13.1239 7.4789C11.7306 6.6784 10.6006 7.34673 10.6006 8.94523V9.08987C10.6006 7.48887 11.7306 6.83301 13.1239 7.62354Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1121_5270",
  x1: 22.3735,
  y1: 8.70654,
  x2: 2.59908,
  y2: 13.9538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.00657,
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2601,
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5122,
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7604,
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1121_5270",
  x1: 34.3601,
  y1: 20,
  x2: 10.2623,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4087,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7754,
  stopColor: "#FFA500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1121_5270",
  x1: 25.3882,
  y1: 22.2973,
  x2: 9.42542,
  y2: 49.0538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_1121_5270",
  x1: 7.92841,
  y1: 0.178683,
  x2: 15.0501,
  y2: 12.1286,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0685,
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4762,
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8009,
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1121_5270"
}, /*#__PURE__*/React.createElement("rect", {
  width: 135,
  height: 40,
  fill: "white",
  transform: "translate(0.664062)"
})));

var SvgGoogleplay = function SvgGoogleplay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 40,
    viewBox: "0 0 136 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleplay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/googleplay.d75239e4.svg";
export { ForwardRef as ReactComponent };